import React, { FC, ReactNode } from 'react';
import * as ST from './styled';
import Success from '~/src/assets/images/success.svg';
import Error from '~/src/assets/images/error.svg';

export interface IPopupResponseProps {
    isOpen: boolean,
    onClose: () => void,
    message?: string,
    type?: 'success' | 'error',
    description?: ReactNode,
}

const PopupResponse: FC<IPopupResponseProps> = ({
    message,
    isOpen,
    type = 'success',
    description,
    onClose
}) => {
    return (
        <ST.ResponsePopup isOpen={isOpen} onClose={onClose}>
            <img src={type === 'success' ? Success : Error} alt='статус'/>
            <ST.Text>{message}</ST.Text>
            {description && <ST.Description>{description}</ST.Description>}
        </ST.ResponsePopup>
    );
};

export default PopupResponse;
